// TODO: rewrite component to prevent ESlint errors
/* eslint-disable */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './EditLocation.css';
import { Modal, Button, PageHeader } from 'react-bootstrap';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { Auth } from 'aws-amplify';
import {
  UpdateLocation,
  Location,
  CreateScheduleChange,
  DeleteScheduleChange,
  ReadScheduleChange,
  GetAvailableFridgeSchemas,
  GetPriceMapTemplates,
  GetPlanogramNames,
  GenerateAprivaDeviceAddress,
  GetLayout,
} from '../libs/GraphQL';
import SeedInventoryButton from './SeedFridgeInventory/SeedInventoryButton';
import DisplayRowString from '../components/DisplayRow/String';
import DisplayRowNumber from '../components/DisplayRow/Number';
import DisplayRowSelect from '../components/DisplayRow/Select';
import DisplayRowSearch from '../components/DisplayRow/Search';
import DisplayRowSelectWithReason from '../components/DisplayRow/SelectWithReason';
import DisplayRowDate from '../components/DisplayRow/Date';
import DisplayRowAddress from '../components/DisplayRow/Address';
import DisplayRowHours from '../components/DisplayRow/Hours';
import DisplayRowStockingSchedule from '../components/DisplayRow/StockingSchedule';
import { EditLocationFields } from '../components/EditLocationFields';
import ScheduleChange from '../components/ScheduleChange';
import DisplayRowAllocation from '../components/DisplayRow/Allocation';
import { ReadonlySelect } from '../components/DisplayRow/ReadonlySelect';

const formatBooleanValue = (value) => {
  if (value === true || value === 'true' || value === 1) {
    return 'Yes';
  } else if (value === false || value === 'false' || value === 0) {
    return 'No';
  } else {
    return '';
  }
};

export default class EditLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentID:
        window.location.pathname.split('/')[
          window.location.pathname.split('/').length - 1
        ],
      data: [],
      errorString: '',
      seedInventoryEnabled: false,
      temporaryState: {},
      // temporaryState is used to preserve values while a modal is opened and used while a modal is closed instead of save.
      alertModal: {
        mode: false,
        text: '',
        acknowledgmentRequired: false,
        acknowledged: false,
        acknowledgmentText: '',
        allowClose: true,
      },
      events: {},
      selectOptions: {},
      hours: {
        allDay: '1',
        fromMon: '',
        toMon: '',
        fromTue: '',
        toTue: '',
        fromWed: '',
        toWed: '',
        fromThu: '',
        toThu: '',
        fromFri: '',
        toFri: '',
        fromSat: '',
        toSat: '',
        fromSun: '',
        toSun: '',
      },
      address: {
        street: '',
        city: '',
        state: '',
        zipCode: '',
      },
      prod: '',
      otherProdUpdateReason: '',
      prodUpdateReasonValues: [
        'End of Holiday Break',
        'First Stocking',
        'Fridge being removed',
        'Fridge not getting removed',
        'Holiday Break',
        'Other',
      ],
      schedule: {
        display: false,
        prettyName: 'test',
        attribute: 'test',
        value: '',
        date: new Date(),
      },
      modal: {},
      location: {},
      layoutDetails: [],
    };
    this.requiredFields = [];
    this.handleChange = this.handleChange.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.handleAllocationChange = this.handleAllocationChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleAddressSave = this.handleAddressSave.bind(this);
    this.handleAllocationOpen = this.handleAllocationOpen.bind(this);
    this.handleAllocationClose = this.handleAllocationClose.bind(this);
    this.handleAllocationSave = this.handleAllocationSave.bind(this);
    this.handleStockingScheduleChange =
      this.handleStockingScheduleChange.bind(this);
    this.handleStockingScheduleSave =
      this.handleStockingScheduleSave.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.handleSaveSchedule = this.handleSaveSchedule.bind(this);
    this.handleScheduleChange = this.handleScheduleChange.bind(this);
    this.showScheduleModal = this.showScheduleModal.bind(this);
    this.showAllocationScheduleModal =
      this.showAllocationScheduleModal.bind(this);
    this.closeScheduleModal = this.closeScheduleModal.bind(this);
    this.scheduleAction = this.scheduleAction.bind(this);
    this.deleteScheduleAction = this.deleteScheduleAction.bind(this);
    this.deleteAllocationScheduleAction =
      this.deleteAllocationScheduleAction.bind(this);
    this.loadScheduledActions = this.loadScheduledActions.bind(this);
    this.completeScheduleAction = this.completeScheduleAction.bind(this);
    this.editScheduleAction = this.editScheduleAction.bind(this);
    this.handleGenerateAprivaDeviceAddress =
      this.handleGenerateAprivaDeviceAddress.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    try {
      const user = await Auth.currentAuthenticatedUser();
      const ldclient = LDClient.initialize(
        process.env.REACT_APP_LAUNCH_DARKLY_CMS || 'nlfaepofjeowiajfpoijewr',
        { key: user.signInUserSession.idToken.payload.email },
      );
      ldclient.on('ready', () => {
        this.setState({
          seedInventoryEnabled: !!ldclient.allFlags()['seed-fridge-inventory'],
        });
      });
    } catch (e) {
      // leave button hidden on LD failure
    }
  }

  validateContent(updateObj) {
    let valid = true;
    let errorString = '';
    let value;
    for (const field in updateObj) {
      if (
        !EditLocationFields.hasOwnProperty(field) ||
        (EditLocationFields.hasOwnProperty(field) &&
          !EditLocationFields[field].hasOwnProperty('validate'))
      ) {
        break;
      }
      for (const name in EditLocationFields[field].validate.names) {
        switch (EditLocationFields[field].validate.names[name]) {
          case 'notEmpty':
            if (updateObj[field] === '') {
              valid = false;
              errorString = `${EditLocationFields[field].prettyName} cannot be empty`;
              this.setState({ errorString });
              break;
            }
            break;
          case 'validIP':
            value = updateObj[field];
            if (
              value.indexOf('farmersfridge') < 0 &&
              !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                value,
              )
            ) {
              valid = false;
              errorString = `${EditLocationFields[field].prettyName} invalid`;
              this.setState({ errorString });
              break;
            }
            break;
          case 'decimal':
            value = Number(updateObj[field]);
            if (isNaN(value)) {
              valid = false;
              errorString = `${EditLocationFields[field].prettyName} cannot be empty`;
              this.setState({ errorString });
              break;
            }
            const minValDec = EditLocationFields[field].validate.min;
            const maxValDec = EditLocationFields[field].validate.max;
            if (value < minValDec || value > maxValDec) {
              valid = false;
              errorString = `${EditLocationFields[field].prettyName} should be a number in the range of ${EditLocationFields[field].validate.min} to ${EditLocationFields[field].validate.max}!`;
              this.setState({ errorString });
              break;
            }
            break;
          case 'integer':
            value = Number(updateObj[field]);
            if (isNaN(value)) {
              valid = false;
              errorString = `${EditLocationFields[field].prettyName} should be a number in the range of ${EditLocationFields[field].validate.min} to ${EditLocationFields[field].validate.max}!`;
              this.setState({ errorString });
              break;
            }
            if (value % 1 !== 0) {
              valid = false;
              errorString = `${EditLocationFields[field].prettyName} cannot be a decimal number`;
              this.setState({ errorString });
              break;
            }
            const minValInt = EditLocationFields[field].validate.min;
            const maxValInt = EditLocationFields[field].validate.max;
            if (value < minValInt || value > maxValInt) {
              valid = false;
              errorString = `${EditLocationFields[field].prettyName} should be a number in the range of ${EditLocationFields[field].validate.min} to ${EditLocationFields[field].validate.max}!`;
              this.setState({ errorString });
              break;
            }
            break;
          case 'email':
            var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
            value = updateObj[field];
            if (!value.match(mailformat)) {
              valid = false;
              errorString = `${EditLocationFields[field].prettyName} is not a valid email id`;
              this.setState({ errorString });
              break;
            }
            break;
          default:
            continue;
        }
        if (!valid) {
          break;
        } else {
          // Handle the case when user fixes the error
          this.setState({ errorString: '' });
        }
      }
    }
    return valid;
  }

  async deleteScheduleAction(eventObj) {
    let response;
    try {
      response = await DeleteScheduleChange({
        uuid: eventObj.uuid,
        actionTime: eventObj.actionTime,
      });
      this.loadScheduledActions();
      // TODO: Handle error with response
      return true;
    } catch (e) {
      console.error(response);
      return false;
    }
  }

  async deleteAllocationScheduleAction(prodWithReason) {
    let eventObj = {
      uuid: prodWithReason.prod.uuid,
      actionTime: prodWithReason.prod.actionTime,
    };
    const deleteProdResponse = this.deleteScheduleAction(eventObj);
    eventObj = {
      uuid: prodWithReason.reason.uuid,
      actionTime: prodWithReason.reason.actionTime,
    };
    const deleteReasonResponse = this.deleteScheduleAction(eventObj);
    return deleteProdResponse && deleteReasonResponse;
  }

  async loadScheduledActions() {
    const response = await ReadScheduleChange(this.state.currentID);
    this.setState({ events: response });
  }

  async scheduleAction(requestObject) {
    try {
      const response = await CreateScheduleChange(requestObject);
      return true;
    } catch (e) {
      return false;
    }
  }
  async completeScheduleAction(eventObj) {
    // delete the previous scheduled change, and run it now
    let response;
    try {
      response = await DeleteScheduleChange({
        uuid: eventObj.uuid,
        actionTime: eventObj.actionTime,
      });
      // Set the action time to 5 seconds from now
      const now = new Date(new Date().getTime() + 5000).toISOString();
      this.setState({
        schedule: {
          ...this.state.schedule,
          date: now,
        },
      });
      eventObj.actionTime = now;
      const resp = await this.handleSaveSchedule(eventObj);
      if (resp) {
        this.loadScheduledActions();
      }
      return resp;
    } catch (e) {
      console.error(response);
      return false;
    }
  }

  async editScheduleAction(eventObj) {
    try {
      this.scheduleAction(eventObj);
      this.showScheduleModal(
        eventObj.change.attribute,
        eventObj.actionTime,
        eventObj.change.value,
      );
      await this.deleteScheduleAction(eventObj);
    } catch (e) {
      console.error('Error in editScheduleAction:', e);
    }
  }

  async componentWillMount() {
    const modal = {};
    const location = {};
    const selectOptions = {};
    for (const key in EditLocationFields) {
      if (EditLocationFields[key].hasOwnProperty('modal')) {
        modal[key] = EditLocationFields[key].modal;
      }
      if (EditLocationFields[key].hasOwnProperty('defaultValue')) {
        location[key] = EditLocationFields[key].defaultValue;
      }
      if (EditLocationFields[key].hasOwnProperty('selectOptions')) {
        selectOptions[key] = EditLocationFields[key].selectOptions;
      }
    }
    this.setState({
      modal,
      location,
      selectOptions,
    });
    this.getLocationById();
    this.uniqueLayoutNames();
    this.uniqueFridgeSchemaNames();
    this.uniquePMTNames();
    this.loadScheduledActions();
    document.addEventListener('keydown', this.escFunction, false);
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      let tempModal = this.state.modal;
      for (const field in this.state.temporaryState) {
        tempModal[field] = false;
        const locationObject = this.state.location;
        locationObject[field] = this.state.temporaryState[field];
        this.setState({
          modal: tempModal,
          location: locationObject,
          temporaryState: {},
          errorString: '',
        });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  async getLocationById(location_data) {
    const id = this.state.currentID;

    if (id.length === 0) {
      this.props.history.push('/Locations/all');
    }

    try {
      const response = { body: '' };
      response.body = await Location(id);
      if (response.body.length === 0) {
        this.props.history.push('/Locations/all');
        return;
      }

      for (const property in this.state.location) {
        if (!response.body[0].hasOwnProperty(property)) {
          response.body[0][property] = '';
        }
        if (property === 'prod') {
          response.body[0][property] =
            response.body[0][property] === ''
              ? 'No'
              : response.body[0][property] === 0
              ? 'No'
              : 'Yes';
        }
      }
      const currResponseString = JSON.stringify(response.body[0]);
      const currResponseObject = JSON.parse(currResponseString);
      const layoutName = currResponseObject.layoutName;
      const locationId = currResponseObject.id || this.state.currentID;
      let items = [];
      if (layoutName && locationId) {
        const layoutDetails = await GetLayout({
          layoutName: layoutName,
          location: locationId,
        });
        items = layoutDetails?.items || [];
      }
      this.setState({ location_orig: currResponseObject });
      this.setState({ location: currResponseObject });
      this.setState({ layoutDetails: items });
    } catch (e) {
      console.error(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      // let errorString = JSON.stringify(e);
      // var errorObject = JSON.parse(errorString);
      alertModal.text =
        'Unable to load this location, Please check your internet and your permissions';
      this.setState({ alertModal });
    }
  }

  async uniqueLayoutNames() {
    try {
      const response = await GetPlanogramNames();
      this.setState((state) => {
        const selectOptions = state.selectOptions;
        selectOptions.layoutName = response.reduce((res, e) => {
          res[e] = e;
          return res;
        }, {});
        return { selectOptions };
      });
    } catch (e) {
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      // var errorString = JSON.stringify(e);
      // var errorObject = JSON.parse(errorString);
      alertModal.text =
        'Unable to load Layout names, Please check your internet and your permissions';
      this.setState({ alertModal });
    }
  }

  async uniquePMTNames() {
    try {
      const response = await GetPriceMapTemplates();
      this.setState((state) => {
        const selectOptions = state.selectOptions;
        selectOptions.priceMapTemplate = response.reduce((res, e) => {
          res[e] = e;
          return res;
        }, {});
        return { selectOptions };
      });
    } catch (e) {
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      // var errorString = JSON.stringify(e);
      // var errorObject = JSON.parse(errorString);
      alertModal.text =
        'Unable to load Price map templates, Please check your internet and your permissions';
      this.setState({ alertModal });
    }
  }

  async uniqueFridgeSchemaNames() {
    try {
      const fridgeSchemaResponse = await GetAvailableFridgeSchemas();
      this.setState((state) => {
        const selectOptions = state.selectOptions;
        selectOptions.fridgeSchema = fridgeSchemaResponse.reduce((res, e) => {
          let val = e?.schemaId + '/latest';
          res[val] = val;
          return res;
        }, {});
        return { selectOptions };
      });
    } catch (e) {
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      alertModal.text =
        'Unable to load Fridge Schema templates, Please check your internet and your permissions';
      this.setState({ alertModal });
    }
  }

  handleChange(event) {
    const locationObject = this.state.location;
    locationObject[event.target.name] = event.target.value;

    this.setState({ location: locationObject });
  }

  async handleGenerateAprivaDeviceAddress(event) {
    try {
      const response = await GenerateAprivaDeviceAddress(this.state.currentID);
      const locationObject = this.state.location;
      locationObject.aprivaDeviceAddress =
        response.data.generateAprivaDeviceAddress;
      this.setState({ location: locationObject });
    } catch (e) {
      console.error(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      const errorString = JSON.stringify(e);
      const errorObject = JSON.parse(errorString);
      if ('response' in errorObject) {
        alertModal.text = errorObject.response.data.message;
      } else {
        alertModal.text =
          'Unable to generate Apriva device address. Please check your internet and your permissions';
      }
      this.setState({ alertModal });
    }
  }

  handleReasonChange(event) {
    const locationObject = this.state.location;
    const reasonToChange = event.target.value;

    if (reasonToChange) {
      locationObject.updateReason = {
        [event.target.name]: reasonToChange,
      };
    }

    this.setState({ location: locationObject });
  }

  handleAddressChange(event) {
    const addressObject = this.state.address;
    addressObject[event.target.name] = event.target.value;
    this.setState({ address: addressObject });
  }

  handleAllocationChange(event) {
    const locationObj = this.state.location;
    if (event.target.name === 'allocationValue') {
      if (
        this.state.temporaryState.prod &&
        this.state.temporaryState.prod !== event.target.value
      ) {
        // allocation has changed,
        // reason should be reset so that user should mandatorily specify why it changed
        if (!locationObj.updateReason) {
          locationObj.updateReason = {};
        }
        locationObj.updateReason.prod = '';
      }
      locationObj.prod = event.target.value;
    } else if (event.target.name === 'reasonValue') {
      if (!locationObj.updateReason) {
        locationObj.updateReason = {};
      }
      locationObj.updateReason.prod = event.target.value;
    } else if (event.target.name === 'other') {
      // User is changing allocation value for a reason not available in the drop down
      // Store it in temporary state otherProdUpdateReason
      this.setState({ otherProdUpdateReason: event.target.value });
    }
    this.setState({ location: locationObj });
  }

  handleDateChange(dateObject) {
    const locationObject = this.state.location;
    locationObject[dateObject.target.name] = JSON.stringify(
      dateObject.target.value,
    ).substring(1, 11);
    this.setState({ location: locationObject });
  }

  handleStockingScheduleChange(changedData) {
    const locationObject = this.state.location;
    const value = changedData.target.value;
    locationObject.stockingSchedule[changedData.target.name] = value;
    this.setState({ location: locationObject });
  }

  handleOpen(field) {
    const tempValue = this.state.location[field];
    const tempStateObject = this.state.temporaryState;
    if (typeof tempValue === 'undefined') {
      tempStateObject[field] = tempValue;
    } else {
      tempStateObject[field] = JSON.parse(JSON.stringify(tempValue));
    }

    const tempModal = this.state.modal;
    tempModal[field] = true;
    this.setState({ modal: tempModal, temporaryState: tempStateObject });
  }

  handleAllocationOpen() {
    // when allocation modal is open, we need to store the value of both prod and updateReason in temp state
    // so that they can be recovered / used for validation if anything changes
    const tempStateObject = this.state.temporaryState;
    const tempProdValue = this.state.location.prod;
    const tempReasonValue =
      this.state.location.updateReason && this.state.location.updateReason.prod
        ? this.state.location.updateReason.prod
        : '';
    if (typeof tempProdValue === 'undefined') {
      tempStateObject.prod = tempProdValue;
    } else {
      tempStateObject.prod = JSON.parse(JSON.stringify(tempProdValue));
    }
    if (typeof tempReasonValue === 'undefined') {
      tempStateObject.prodUpdateReason = tempReasonValue;
    } else {
      tempStateObject.prodUpdateReason = JSON.parse(
        JSON.stringify(tempReasonValue),
      );
    }
    const tempModal = this.state.modal;
    tempModal.prod = true;
    this.setState({ modal: tempModal, temporaryState: tempStateObject });
  }

  handleAllocationClose() {
    // if modal is closed without any changes, retrieve values of prod and updateReason from tempState
    const tempModal = this.state.modal;
    tempModal.prod = false;
    const locationObj = this.state.location;
    locationObj.prod = this.state.temporaryState.prod;
    if (!locationObj.updateReason) {
      locationObj.updateReason = {};
    }
    locationObj.updateReason.prod = this.state.temporaryState.prodUpdateReason;
    this.setState({ otherProdUpdateReason: '' });
    this.setState({
      modal: tempModal,
      location: locationObj,
      errorString: '',
      temporaryState: {},
    });
  }

  clearField(field) {
    const locationObject = this.state.location;
    locationObject[field] = this.state.temporaryState[field];
    if (field === 'prod') {
      // clear updateReason too
      if (!locationObject.updateReason) {
        locationObject.updateReason = {};
      }
      locationObject.updateReason.prod =
        this.state.temporaryState.prodUpdateReason;
    }
    this.setState({ location: locationObject, errorString: '' });
  }

  handleClose(field) {
    const tempModal = this.state.modal;
    tempModal[field] = false;
    const locationObject = this.state.location;
    locationObject[field] = this.state.temporaryState[field];
    this.setState({
      modal: tempModal,
      location: locationObject,
      errorString: '',
      temporaryState: {},
    });
  }

  handleSave(field) {
    const updateObj = {};
    const location = this.state.location;

    if (location.hasOwnProperty(field)) {
      const updateReason = location?.updateReason?.[field];

      updateObj[field] = location[field];

      if (updateReason) {
        updateObj.updateReason = {
          [field]: updateReason,
        };
      }

      if (this.validateContent(updateObj)) {
        this.handleClose(field);
        this.submit(updateObj);
      }
    }
  }

  showScheduleModal(attribute, date = new Date(), value = null) {
    const field = attribute;
    const updateObj = {};
    if (this.state.location.hasOwnProperty(field)) {
      updateObj[field] = value || this.state.location[field];
      if (this.validateContent(updateObj)) {
        this.setState({
          schedule: {
            display: true,
            prettyName: EditLocationFields[attribute].prettyName,
            attribute,
            value: value || this.state.location[attribute],
            date,
          },
        });
      }
    }
  }

  showAllocationScheduleModal() {
    // this is the modal that is shown when we schedule changes to allocation
    const prod = this.state.location.prod;
    let reason =
      this.state.location.updateReason && this.state.location.updateReason.prod
        ? this.state.location.updateReason.prod
        : '';
    if (
      !this.state.prodUpdateReasonValues.includes(reason) ||
      reason === 'Other'
    ) {
      reason = this.state.otherProdUpdateReason;
    }
    let errorString = '';
    if (reason === '') {
      errorString = 'Reason cannot be empty';
      this.setState({ errorString });
      return;
    }
    this.setState({
      schedule: {
        display: true,
        prettyName: EditLocationFields.prod.prettyName,
        attribute: 'prod',
        value: `${prod};${reason}`,
        date: new Date(),
      },
    });
  }

  handleScheduleChange(event) {
    const scheduleObject = this.state.schedule;
    scheduleObject.date = event.target.value;
    this.setState({ schedule: scheduleObject });
  }

  async handleSaveSchedule(eventObj = null) {
    console.log(this.state.schedule);
    const requestObject = [
      {
        location: this.state.currentID,
        attribute: eventObj
          ? eventObj.change.attribute
          : this.state.schedule.attribute,
        value: eventObj ? eventObj.change.value : this.state.schedule.value,
        dateTime: eventObj
          ? eventObj.actionTime
          : this.state.schedule.date.toJSON(),
      },
    ];

    const resp = await this.scheduleAction(requestObject);

    // On Success:
    if (resp) {
      // Clear the Changes that were just scheduled
      // This allows user to have a clean slate
      this.clearField(
        eventObj ? eventObj.change.attribute : this.state.schedule.attribute,
      );
      this.loadScheduledActions();
      this.closeScheduleModal();
    }
  }

  async handleAllocationScheduleSave() {
    // schedule changes to ready for allocation and its reason
    const value = this.state.schedule.value;
    console.log('schedule value: ', value);
    const prod = value.split(';')[0].trim();
    const reason = value.split(';')[1].trim();
    console.log('prod: ', prod);
    console.log('reason: ', reason);
    const updateReason = this.state.location.updateReason
      ? this.state.location.updateReason
      : {};
    updateReason.prod = reason;
    let requestObject = [
      {
        location: this.state.currentID,
        attribute: 'prod',
        value: prod === 'Yes' ? 1 : 0,
        dateTime: this.state.schedule.date.toJSON(),
      },
    ];

    const prodResponse = await this.scheduleAction(requestObject);

    requestObject = [
      {
        location: this.state.currentID,
        attribute: 'updateReason',
        value: updateReason,
        dateTime: this.state.schedule.date.toJSON(),
      },
    ];

    const reasonResponse = await this.scheduleAction(requestObject);

    // On Success:
    if (prodResponse && reasonResponse) {
      // Clear the Changes that were just scheduled
      // This allows user to have a clean slate
      this.clearField(this.state.schedule.attribute);
      this.setState({ otherProdUpdateReason: '' });
      this.loadScheduledActions();
      this.closeScheduleModal();
    }
  }

  closeScheduleModal() {
    this.setState({
      schedule: {
        display: false,
        prettyName: '',
        attribute: '',
        value: new Date(),
      },
    });
  }

  handleAddressSave() {
    const address = this.state.address;
    for (const key in address) {
      if (address[key].toString() === '') {
        const errorString = `${key} cannot be empty`;
        this.setState({ errorString });
        return;
      }
    }
    const locationObject = this.state.location;
    locationObject.address = `${address.street}, ${address.city}, ${address.state} ${address.zipCode}`;
    this.setState({ location: locationObject });
    this.handleSave('address');
  }

  handleAllocationSave() {
    // handle updates to allocation and reason
    let errorString = '';
    if (
      this.state.location.prod.toString() !==
      this.state.temporaryState.prod.toString()
    ) {
      // Ready for allocation has changed
      // Reason cannot be empty
      if (
        !this.state.location.updateReason ||
        !this.state.location.updateReason.prod
      ) {
        errorString = 'Reason cannot be empty';
        this.setState({ errorString });
        return;
      }
    } else if (
      this.state.location.updateReason &&
      this.state.location.updateReason.prod ===
        this.state.temporaryState.prodUpdateReason
    ) {
      // allocation value has not changed, neither has reason value
      this.handleClose('prod');
      this.setState({ otherProdUpdateReason: '' });
      return;
    }
    const requestObject = {};
    if (this.state.location.prod === 'No') {
      requestObject.prod = 0;
    } else {
      requestObject.prod = 1;
    }
    requestObject.updateReason = this.state.location.updateReason;
    if (
      requestObject.updateReason &&
      (!this.state.prodUpdateReasonValues.includes(
        requestObject.updateReason.prod,
      ) ||
        requestObject.updateReason.prod === 'Other')
    ) {
      requestObject.updateReason.prod = this.state.otherProdUpdateReason;
    }
    console.log(requestObject);
    this.handleClose('prod');
    this.setState({ otherProdUpdateReason: '' });
    this.submit(requestObject);
  }

  handleStockingScheduleSave() {
    const stockingSchedule = this.state.location.stockingSchedule;
    const requestObject = {};
    requestObject.stockingSchedule = stockingSchedule;
    this.handleClose('stockingSchedule');
    this.submit(requestObject);
  }

  async submit(requestObject) {
    try {
      requestObject.id = this.state.currentID;

      var response = await UpdateLocation(requestObject);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      alertModal.text = 'Successfully updated';
      if (requestObject.hasOwnProperty('ip')) {
        alertModal.acknowledgmentRequired = true;
        alertModal.allowClose = false;
        alertModal.acknowledgmentText =
          ' I have updated the corresponding cradlepoint record(s) in Keeper';
      }
      this.setState({ alertModal });
    } catch (e) {
      console.error(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      const errorString = JSON.stringify(e);
      const errorObject = JSON.parse(errorString);
      if ('response' in errorObject) {
        alertModal.text = errorObject.response.data.message;
      } else if ('errors' in errorObject) {
        alertModal.text = errorObject.errors[0].message;
      } else {
        alertModal.text =
          'Unable to Edit, Please check your internet and your permissions';
      }
      this.setState({ alertModal });
    }
    this.getLocationById();
  }

  render() {
    return (
      <div id="locationDetail" className="form-group col-sm-12">
        <div style={{ padding: '8px 0', textAlign: 'right' }}>
          <SeedInventoryButton
            locationId={this.state.currentID}
            enabled={this.state.seedInventoryEnabled}
          />
        </div>
        <div id="alertBox">
          <Modal show={this.state.alertModal.mode}>
            <Modal.Body>
              <div className="form-group">{this.state.alertModal.text}</div>
              {this.state.alertModal.acknowledgmentRequired && (
                <div className="form-group">
                  Before closing, please confirm:
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.alertModal.acknowledged}
                      onChange={(e) => {
                        const alertModal = this.state.alertModal;
                        alertModal.acknowledged = e.target.checked;
                        alertModal.allowClose = e.target.checked;
                        this.setState({ alertModal });
                      }}
                    />
                    {this.state.alertModal.acknowledgmentText}
                  </label>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                type="button"
                className="btn btn-warning"
                disabled={!this.state.alertModal.allowClose}
                onClick={() => {
                  const alertModal = this.state.alertModal;
                  alertModal.mode = false;
                  alertModal.acknowledged = false;
                  alertModal.acknowledgmentRequired = false;
                  alertModal.acknowledgmentText = '';
                  this.setState({ alertModal });
                }}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>
        <PageHeader>
          {this.state.currentID}
          {this.state.location.lastModified ? (
            <small>
              {' '}
              last modified:{' '}
              {new Date(this.state.location.lastModified).toLocaleString()}
            </small>
          ) : null}
        </PageHeader>
        <div className="button-container">
          <Link to={`/locations/health/${this.state.currentID}`}>
            <Button bsStyle="primary" className="button-spacing">
              Health
            </Button>
          </Link>
          <Link to={`/locations/inventory/${this.state.currentID}`}>
            <Button bsStyle="primary">Inventory</Button>
          </Link>
        </div>
        <table id="locationDetailTable">
          <tbody>
            <tr>
              <th width="200">Property</th>
              <th className="detailColumn">Value</th>
            </tr>
            {Object.keys(EditLocationFields).map((displayField) => {
              if (
                displayField === 'ip' &&
                this.state.location[displayField] !== '' &&
                this.state.location[displayField].includes('farmersfridge.chi')
              ) {
                EditLocationFields[displayField].displayComponent =
                  'DisplayRowString';
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowAprivaDeviceAddress'
              ) {
                return (
                  <DisplayRowString
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit={this.state.modal[displayField]}
                    value={this.state.location[displayField]}
                    errorString={this.state.errorString}
                    handleGenerate={this.handleGenerateAprivaDeviceAddress}
                    handleChange={this.handleChange}
                    handleOpen={() => this.handleOpen(displayField)}
                    handleClose={() => this.handleClose(displayField)}
                    handleSave={() => this.handleSave(displayField)}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowAprivaDeviceAddressViewOnly'
              ) {
                return (
                  <DisplayRowString
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit=""
                    value={this.state.location[displayField]}
                    errorString=""
                    handleGenerate={() => {}}
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    deleteScheduleAction={() => {}}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowString'
              ) {
                return (
                  <DisplayRowString
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit={this.state.modal[displayField]}
                    value={this.state.location[displayField]}
                    errorString={this.state.errorString}
                    handleChange={this.handleChange}
                    handleOpen={() => this.handleOpen(displayField)}
                    handleClose={() => this.handleClose(displayField)}
                    handleSave={() => this.handleSave(displayField)}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowStringViewOnly'
              ) {
                return (
                  <DisplayRowString
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit=""
                    value={this.state.location[displayField]}
                    errorString=""
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    deleteScheduleAction={() => {}}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowNumber'
              ) {
                return (
                  <DisplayRowNumber
                    prettyName={EditLocationFields[displayField].prettyName}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit={this.state.modal[displayField]}
                    value={this.state.location[displayField]}
                    errorString={this.state.errorString}
                    handleChange={this.handleChange}
                    handleOpen={() => this.handleOpen(displayField)}
                    handleClose={() => this.handleClose(displayField)}
                    handleSave={() => this.handleSave(displayField)}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowNumberViewOnly'
              ) {
                return (
                  <DisplayRowNumber
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit=""
                    value={this.state.location[displayField]}
                    errorString=""
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    deleteScheduleAction={() => {}}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowSelect'
              ) {
                return (
                  <DisplayRowSelect
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    displayValue={
                      EditLocationFields[displayField].isDisplayBoolean
                        ? formatBooleanValue(this.state.location[displayField])
                        : this.state.location[displayField]
                    }
                    value={this.state.location[displayField]}
                    errorString={this.state.errorString}
                    options={this.state.selectOptions[displayField]}
                    default="Choose an option"
                    handleChange={this.handleChange}
                    handleOpen={() => {
                      this.handleOpen(displayField);
                    }}
                    handleClose={() => {
                      this.handleClose(displayField);
                    }}
                    handleSave={() => {
                      this.handleSave(displayField);
                    }}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowSelectViewOnly'
              ) {
                return (
                  <DisplayRowSelect
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    edit=""
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    displayValue={
                      EditLocationFields[displayField].isDisplayBoolean
                        ? formatBooleanValue(this.state.location[displayField])
                        : this.state.location[displayField]
                    }
                    value={this.state.location[displayField]}
                    errorString=""
                    options={this.state.selectOptions[displayField]}
                    default="Choose an option"
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    deleteScheduleAction={() => {}}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowSearch'
              ) {
                return (
                  <DisplayRowSearch
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    displayValue={
                      EditLocationFields[displayField].isDisplayBoolean
                        ? formatBooleanValue(this.state.location[displayField])
                        : this.state.location[displayField]
                    }
                    options={this.state.selectOptions[displayField]}
                    default="Choose an option"
                    value={this.state.location[displayField]}
                    errorString={this.state.errorString}
                    handleChange={this.handleChange}
                    handleOpen={() => this.handleOpen(displayField)}
                    handleClose={() => this.handleClose(displayField)}
                    handleSave={() => this.handleSave(displayField)}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                    completeScheduleAction={this.completeScheduleAction}
                    editScheduleAction={this.editScheduleAction}
                    layoutDetails={
                      EditLocationFields[displayField].hasLayoutDetails
                        ? this.state.layoutDetails
                        : null
                    }
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowSelectWithReason'
              ) {
                return (
                  <DisplayRowSelectWithReason
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    displayValue={
                      EditLocationFields[displayField].isDisplayBoolean
                        ? formatBooleanValue(this.state.location[displayField])
                        : this.state.location[displayField]
                    }
                    options={this.state.selectOptions[displayField]}
                    placeholder="Choose an option"
                    value={this.state.location[displayField]}
                    errorString={this.state.errorString}
                    handleChange={this.handleChange}
                    handleReasonChange={this.handleReasonChange}
                    handleOpen={() => {
                      this.handleOpen(displayField);
                    }}
                    handleClose={() => {
                      this.handleClose(displayField);
                    }}
                    handleSave={() => {
                      this.handleSave(displayField);
                    }}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                    reasonValue={
                      this.state.location?.updateReason?.[displayField]
                    }
                    reasonsToChange={
                      EditLocationFields[displayField].reasonsToChange
                    }
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowSelectWithReasonViewOnly'
              ) {
                return (
                  <DisplayRowSelectWithReason
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit=""
                    displayValue={
                      EditLocationFields[displayField].isDisplayBoolean
                        ? formatBooleanValue(this.state.location[displayField])
                        : this.state.location[displayField]
                    }
                    options={{}}
                    placeholder=""
                    value={this.state.location[displayField]}
                    errorString=""
                    handleChange={() => {}}
                    handleReasonChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    deleteScheduleAction={() => {}}
                    reasonValue=""
                    reasonsToChange={[]}
                  />
                );
              }

              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowAllocation'
              ) {
                let reason = '';
                if (
                  this.state.location.updateReason &&
                  this.state.location.updateReason.prod
                ) {
                  reason = this.state.location.updateReason.prod;
                }
                return (
                  <DisplayRowAllocation
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    value={this.state.location[displayField]}
                    allocationValue={this.state.location[displayField]}
                    reasonValues={this.state.prodUpdateReasonValues}
                    reasonValue={reason}
                    handleChange={this.handleAllocationChange}
                    handleOpen={() => {
                      this.handleAllocationOpen();
                    }}
                    handleClose={() => {
                      this.handleAllocationClose();
                    }}
                    handleSave={() => {
                      this.handleAllocationSave([displayField]);
                    }}
                    handleSchedule={() => {
                      this.showAllocationScheduleModal();
                    }}
                    deleteScheduleAction={this.deleteAllocationScheduleAction}
                    errorString={this.state.errorString}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowAllocationViewOnly'
              ) {
                return (
                  <DisplayRowAllocation
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit=""
                    value={this.state.location[displayField]}
                    allocationValue={this.state.location[displayField]}
                    reasonValues={[]}
                    reasonValue=""
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    deleteScheduleAction={() => {}}
                    errorString=""
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowAddress'
              ) {
                return (
                  <DisplayRowAddress
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    value={this.state.location[displayField]}
                    streetValue={this.state[displayField].street}
                    cityValue={this.state[displayField].city}
                    stateValue={this.state[displayField].state}
                    zipcodeValue={this.state[displayField].zipCode}
                    handleChange={this.handleAddressChange}
                    handleOpen={() => {
                      this.handleOpen([displayField]);
                    }}
                    handleClose={() => {
                      this.handleClose([displayField]);
                    }}
                    handleSave={() => {
                      this.handleAddressSave();
                    }}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    errorString={this.state.errorString}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowAddressViewOnly'
              ) {
                return (
                  <DisplayRowAddress
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit=""
                    value={this.state.location[displayField]}
                    streetValue=""
                    cityValue=""
                    stateValue=""
                    zipcodeValue=""
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    errorString=""
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowDate'
              ) {
                return (
                  <DisplayRowDate
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    value={this.state.location[displayField]}
                    handleChange={this.handleDateChange}
                    handleOpen={() => {
                      this.handleOpen(displayField);
                    }}
                    handleClose={() => {
                      this.handleClose(displayField);
                    }}
                    handleSave={() => {
                      this.handleSave(displayField);
                    }}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                    errorString={this.state.errorString}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowDateViewOnly'
              ) {
                return (
                  <DisplayRowDate
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit=""
                    value={this.state.location[displayField]}
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    deleteScheduleAction={() => {}}
                    errorString=""
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowDateTime'
              ) {
                return (
                  <DisplayRowDate
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    value={this.state.location[displayField]}
                    handleChange={this.handleDateChange}
                    handleOpen={() => {
                      this.handleOpen(displayField);
                    }}
                    handleClose={() => {
                      this.handleClose(displayField);
                    }}
                    handleSave={() => {
                      this.handleSave(displayField);
                    }}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                    errorString={this.state.errorString}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowStockingSchedule'
              ) {
                return (
                  <DisplayRowStockingSchedule
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    value={this.state.location[displayField]}
                    handleChange={this.handleStockingScheduleChange}
                    handleOpen={() => {
                      this.handleOpen(displayField);
                    }}
                    handleClose={() => {
                      this.handleClose(displayField);
                    }}
                    handleSave={() => {
                      this.handleStockingScheduleSave();
                    }}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    deleteScheduleAction={this.deleteScheduleAction}
                    errorString={this.state.errorString}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowStockingScheduleViewOnly'
              ) {
                return (
                  <DisplayRowStockingSchedule
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    events={this.state.events}
                    edit=""
                    value={this.state.location[displayField]}
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    deleteScheduleAction={() => {}}
                    errorString=""
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowHours'
              ) {
                return (
                  <DisplayRowHours
                    prettyName={EditLocationFields[displayField].prettyName}
                    edit={this.state.modal[displayField]}
                    key={displayField}
                    id={displayField}
                    hours={this.state.hours}
                    setHours={(hours) => this.setState({ hours })}
                    displayString={this.state.location.hours}
                    value={this.state[displayField]}
                    handleChange={this.handleHoursChange}
                    handleOpen={() => {
                      this.handleOpen(displayField);
                    }}
                    handleClose={() => {
                      this.handleClose(displayField);
                    }}
                    handleSave={() => {
                      this.handleHoursSave(displayField);
                    }}
                    handleSchedule={() => {
                      this.showScheduleModal(displayField);
                    }}
                    errorString={this.state.errorString}
                    setErrorString={(errorString) =>
                      this.setState({ errorString })
                    }
                    submitRequest={(requestObject) =>
                      this.submit(requestObject)
                    }
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent ===
                'DisplayRowHoursViewOnly'
              ) {
                return (
                  <DisplayRowHours
                    prettyName={EditLocationFields[displayField].prettyName}
                    tooltip={EditLocationFields[displayField].tooltip || ''}
                    key={displayField}
                    id={displayField}
                    hours={this.state.hours}
                    setHours={() => {}}
                    displayString={this.state.location.hours}
                    value={this.state[displayField]}
                    edit=""
                    handleChange={() => {}}
                    handleOpen={() => {}}
                    handleClose={() => {}}
                    handleSave={() => {}}
                    handleSchedule={() => {}}
                    errorString=""
                    setErrorString={() => {}}
                    submitRequest={() => {}}
                  />
                );
              }
              if (
                EditLocationFields[displayField].displayComponent === 'value'
              ) {
                let field = this.state.location[displayField];
                if (EditLocationFields[displayField].format) {
                  field = EditLocationFields[displayField].format(field);
                }

                return (
                  <tr key={displayField}>
                    <td>{EditLocationFields[displayField].prettyName}</td>
                    <td>
                      <span>
                        {EditLocationFields[displayField].isDisplayBoolean
                          ? field?.toString() === '1'
                            ? 'Yes'
                            : 'No'
                          : field}
                      </span>
                    </td>
                  </tr>
                );
              } else if (
                EditLocationFields[displayField].displayComponent ===
                'ReadonlySelect'
              ) {
                return (
                  <ReadonlySelect
                    field={EditLocationFields[displayField]}
                    value={this.state.location[displayField]}
                  />
                );
              }
              return (
                <tr key={displayField}>
                  <td>{EditLocationFields[displayField].prettyName}</td>
                  <td>Unknown Field</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <ScheduleChange
          prettyName={this.state.schedule.prettyName}
          edit={this.state.schedule.display}
          id={this.state.schedule.attribute}
          value={this.state.schedule.value}
          date={this.state.schedule.date}
          handleChange={this.handleScheduleChange}
          handleClose={this.closeScheduleModal}
          handleSave={() => {
            if (this.state.schedule.attribute === 'prod') {
              this.handleAllocationScheduleSave();
            } else this.handleSaveSchedule();
          }}
        />
      </div>
    );
  }
}
